import React from "react";
import { Card } from "antd";
import Man from "../../../assets/teams/man.png";
import Everton from "../../../assets/teams/everton.png";
import Villa from "../../../assets/teams/villa.png";
import Watford from "../../../assets/teams/wat.png";
import { Button } from "../../../components";

const forums = [
  {
    title: "Manchester United",
    count: 50,
    image: Man,
  },
  {
    title: "Arsenal News",
    count: 30,
    image: Everton,
  },
  {
    title: "Brookyln Simmons",
    count: 24,
    image: Villa,
  },
  {
    title: "Wilson Arinze",
    count: 37,
    image: Watford,
  },
];

const SuggestedForums = () => {
  return (
    <>
      <Card className="sidebarCard">
        {forums.map((item, index) => (
          <div key={index} className="py-2 flex items-center">
            <div className="w-20 h-16 flex overflow-hidden">
              <img src={item.image} />
            </div>
            <div className="w-full ml-2">
              <h4>{item.title}</h4>
              <p>{item.count} Connections</p>
              <Button
                type="primary"
                shape="round"
                className="button rounded-button"
                title="Join"

              />
            </div>
          </div>
        ))}
      </Card>
    </>
  );
};

export default SuggestedForums;
